import React, {useEffect, useState} from 'react'
import PageTitle from "../../Utils/smsTitle";
import {SubHeader} from "../../../Containers/SubHeader";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import * as snackbarActions from '../../../actions/snackbarActions'
import MainSnackbar from "../../Utils/Snackbar/SmsSnackbar";
import { PLContainer, RightAlignedContainer} from '../../Utils/styledComponents';
import { faClipboardList } from '@fortawesome/free-solid-svg-icons/faClipboardList';
import { DataExportButton } from '../../Utils/Buttons/DataExportationButton';
import Card  from '@material-ui/core/Card';
import axios from "axios";
import { config } from "../../../Helpers/env";
import {errorMessages} from "../../../Helpers/ErrorMessages";
import {HospitalAddress} from "../../Utils/HospitalAddress";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import {COATableCustomCell} from "../ChartofAccounts/TreeViewComponent";
import {dateConvert, formatDate} from '../../Utils/ConvertDate';
import { Table, TableBody, TableCell } from '@material-ui/core';
import { useExcelReports, usePdfDownload } from '../../Utils/ReusableComponents/useExcelExport';
import {useDebounce} from "../../Lab/useDebounce";
import TextField from "../../Utils/FormInputs/TextField";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col"
import { BackButton } from '../../Utils/Buttons/DataExportationButton';



const TrialBalance = ({actions, snackbar}) => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState('idle')
    const [dates, setDates] = useState({"start_date": dateConvert(), "end_date": dateConvert()})
    const [search, setSearch] = useState("")
    const [searchValue] = useDebounce(search, 500)

    const {start_date, end_date} = dates

    useEffect (() =>{
    axios.get(`${config.smsUrl}/accounting/get_new_trial_balance_report`,{params:{start_date: start_date, end_date: end_date, search:searchValue}}).then(res => {
        const data = res.data;
        const dt = data ? data : {};
        setData(dt)
        setLoading('success')
        }).catch(err => {
            errorMessages(err, null, actions)
        })
    },[start_date, end_date, searchValue])
    

    const handleChange = (e) => {
        const { name, value } = e.target; 
        setDates({ ...dates, [name]: value });
    };

    const closeSnackbar = () => {
        actions.snackbarActions.hideSnackbar()
    }
    const isLoading = loading === 'pending';
    const isSuccess = loading === 'success';
    const isError = loading === 'error';


    const {open, variant, message} = snackbar;





    // const fileName = `Trial Balance data`

    const excelObj = {file_name:'Trial Balance data', url:'accounting/get_new_trial_balance_report_exports',params:{ start_date:start_date, end_date:end_date, download: 1}}

    const pdfObj = {file_name:'Trial Balance data',url:'accounting/get_new_trial_balance_report_exports',params:{ start_date:start_date, end_date:end_date, download: 2}}


    

    const {exportExcel, isLoading:isLoadingExcel} = useExcelReports(actions,excelObj)
    const {exportPdf, isLoading:isLoadingPdf} = usePdfDownload(actions,pdfObj)
   
    // const pdfObj = {file_name:'Trial Balance data', url:'cbilling/insurance_summary_exports', params:{...params, download_type:2, provider_id:provider?.value}}

    // const {exportPdf, isLoadingPdf} = usePdfDownload(actions, pdfObj)

    // const {exportExcel, isLoading:isLoadingExcel} = useExcelReports(actions, {file_name:'Insurance Summary List', url:'cbilling/insurance_summary_exports',
    //     params:{...params, download_type:1, provider_id:provider?.value}})





    return (
        <div className='journals'>
            <PageTitle title="Trial Balance"/>
            <SubHeader title="Reports" subTitle="Trial Balance">
                <FontAwesomeIcon icon={faClipboardList}/>
            </SubHeader>

            <MainSnackbar message={message} open={open} handleCloseBar={closeSnackbar} variant={variant}/>

            <PLContainer>

                <Card className="mx-2 my-3">
                <BackButton to='/reports/generalreports' text='General Reports' />

                        <RightAlignedContainer>
                                 <DataExportButton isLoading={isLoadingExcel || isLoadingPdf} downLoadPdf={exportPdf}
                                            exportCsv={exportExcel} />
                                {/* <DataExportButton isLoading={isLoadingExcel || isLoadingPdf} downLoadPdf={exportPdf} exportCsv={exportExcel}/> */}
                        </RightAlignedContainer>
                    <div className="row p-3">
                        <div className="col-lg-8">
                            <Row>
                                <Col>
                                    <Form.Group as={Row}>
                                        <Col sm={2} style={{display:"flex", justifyContent:"center", alignItems:'center'}}>
                                            <label className="" htmlFor="startDate">
                                                From&nbsp;
                                            </label>
                                        </Col>
                                        <Col sm={8}>
                                            <TextField
                                                id='startDate'
                                                type="date"
                                                name="start_date"
                                                value={start_date}
                                                onChange={handleChange}
                                                required
                                                data-testid="start-date"
                                                // defaultValue={reverseDate())}
                                            />
                                        </Col>
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group as={Row}>
                                        <Col sm={2} style={{display:"flex", justifyContent:"center", alignItems:'center'}}>
                                            <label  className="ml-4" htmlFor="endDate">
                                                To&nbsp;
                                            </label>
                                        </Col>
                                        <Col sm={8}>
                                            <TextField
                                                id='endDate'
                                                type="date"
                                                name="end_date"
                                                value={end_date}
                                                onChange={handleChange}
                                                required
                                                data-testid="end-date"
                                                // defaultValue={reverseDate())}
                                            />
                                        </Col>
                                    </Form.Group>
                                </Col>
                            </Row>

                        </div>
                        <div className="col-lg-4">
                            <RightAlignedContainer>
                                <TextField type="text" data-testid="search-trial-balance" placeholder="Search..." value={search} onChange={(e)=>setSearch(e.target.value)}/>
                            </RightAlignedContainer>
                        </div>
                    </div>
                    {/*<div className="px-8 py-16"*/}
                    {/*     style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>*/}
                    {/*    <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}*/}
                    {/*         className='m-3'>*/}

                    {/*    </div>*/}
                    {/*    /!* <div className="">*/}
                    {/*        <PrintPdfButtons*/}
                    {/*            downloadPdf={() => {}}*/}
                    {/*            handlePrint={handlePrint}*/}
                    {/*        />*/}
                    {/*    </div> *!/*/}
                    {/*</div>*/}
                    <div>
                        <table className="table table-sm table-borderless prescription-table">
                            <HospitalAddress/>

                            <tr>
                                <td align="center">
                                    <h5>
                                        <strong>Trial Balance</strong>
                                    </h5>
                                </td>
                            </tr>
                            <tr>
                                <td align='center'><h6><strong>As of {formatDate(end_date)}</strong></h6></td>
                            </tr>
                        </table>

                        <Table style={{display: 'flex', flexDirection: 'column'}}>
                            <TableBody style={{display: 'flex', flexDirection: 'column' }}>
                                <TableRow className="mt-5" style={{ display: 'flex', flexDirection: 'row' }}>
                                    <TableCell className="w-50" style={{ display: 'flex', justifyContent: 'start', alignItems: 'center' }}></TableCell>
                                    <TableCell className="w-25" style={{ display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
                                        <strong>DEBITS</strong>
                                    </TableCell>
                                    <TableCell className="w-25" style={{ display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
                                        <strong>CREDITS</strong>
                                    </TableCell>

                                </TableRow>
                            </TableBody>
                        </Table>
                       

                        <Table className="" data-testid="bal">
                            <TableBody className="">
                                {data?.categories &&
                                Object.entries(data?.categories).length > 0 ? (
                                    Object.entries(data?.categories).map(
                                        ([key, values], idx) => (
                                            <>
                                                <Table className="" key={idx} style={{ display: 'flex', flexDirection: 'column' }}>
                                                    <TableHead
                                                        style={{ display: 'flex', justifyContent: 'start', marginLeft: '2px', marginTop: '3px' }}
                                                        data-toggle={`category-${key}`}
                                                    >
                                                        <TableRow className='ml-3'>
                                                            <strong>{key}</strong>
                                                        </TableRow>
                                                    </TableHead>

                                                    <TableBody>
                                                        <Table id={`category-${key}`}>
                                                            {values?.account_details &&
                                                            values?.account_details.length > 0 ? (
                                                                values?.account_details.map(
                                                                    (accountDetail, index) => (
                                                                        <TableRow
                                                                            style={{ display: 'flex', flexDirection: 'row' }}
                                                                            key={index}
                                                                        >
                                                                            <TableCell
                                                                               style={{ width: '50%', display: 'flex', justifyContent: 'start', alignItems: 'center', marginLeft:"25px" }}
                                                                                // data-testid={`account_name`}
                                                                                data-testid={accountDetail.account}
                                                                            >
                                                                                {accountDetail?.account}
                                                                            </TableCell>
                                                                            <TableCell
                                                                                style={{width: '25%', display: 'flex', justifyContent: 'end', alignItems: 'center' }}
                                                                                data-testid={`${accountDetail.account}_debit`}
                                                                            >
                                                                                {accountDetail?.debit}
                                                                            </TableCell>
                                                                            <TableCell
                                                                                style={{width: '25%', display: 'flex', justifyContent: 'end', alignItems: 'center' }}
                                                                                data-testid={`${accountDetail.account}_credit`}
                                                                            >
                                                                                {accountDetail?.credit}
                                                                            </TableCell>

                                                                        </TableRow>
                                                                    )
                                                                )
                                                            ) : (
                                                                <TableRow style={{ display: 'flex' }}>
                                                                    <TableCell style={{ width: '100%', display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
                                                                        No Data available
                                                                    </TableCell>
                                                                </TableRow>
                                                            )}
                                                        </Table>
                                                    </TableBody>
                                                </Table>
                                            </>
                                        )
                                    )
                                ) : (
                                    <TableRow>
                                        <COATableCustomCell align="center">
                                            No Data available
                                        </COATableCustomCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>

                        <Table>
                            <TableBody>
                                <TableRow style={{ display: 'flex', marginTop: '5px' }}>
                                    <TableCell style={{ width: '50%', display: 'flex', justifyContent: 'start', alignItems: 'center' }}>
                                        <strong>Total</strong>
                                    </TableCell>
                                    <TableCell style={{ width: '25%', display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
                                        {data?.total_debits ?? 0}
                                    </TableCell>
                                    <TableCell style={{ width: '25%', display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
                                        {data?.total_credits ?? 0}
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                        
                    </div>
                  
                </Card>
            </PLContainer>
        </div>)
}
function mapStateToProps(state) {
    const {snackbar} = state;
    return {snackbar}
}

function mapDispatchToProps(dispatch) {
    return {actions: {snackbarActions: bindActionCreators(snackbarActions, dispatch)}}
}

export default connect(mapStateToProps, mapDispatchToProps)(TrialBalance);

